module.exports = function() {
    var Ajax = {
        delayTimer: 0,
        originalContent: null
    };

    Ajax.init = function() {

    };

    var _defaultparams = {
        method: 'GET',
        dataType: 'json',
        data: {}
    };

    Ajax.send = function(uri, params, onSuccess, onError) {
        params = $.extend({}, _defaultparams, params);

        params.url = uri;

        params.success = function(data) {
            if(typeof onSuccess === 'function') {
                return onSuccess.call(this, data);
            }
        };
        params.error = function(xhr, status, error) {
            if(typeof onError === 'function') {
                return onError.call(this, xhr, status, error);
            }
        };
        var ajaxcall = $.ajax(params);

        //Return the ajax call itself - this allows the caller to abort the ajax call
        return ajaxcall;
    };

    Ajax.loadingStarted = function($button) {
        //Set the submit button to be a loading icon
        Ajax.originalContent = $button.html();
        var originalWidth = $button.data('width') ? parseInt($button.data('width')) : $button.width();
        $button.width(originalWidth + 'px');
        $button.html('<i class="fa fa-spin fa-spinner"></i>');
        $button.prop('disabled', true);
    };
    Ajax.loadingCompleted = function($button, setWidth) {
        if (typeof setWidth === 'undefined') {
            setWidth = true;
        }
        $button.html(Ajax.originalContent);
        $button.prop('disabled', false);
        if (setWidth === true) {
            $button.width('100%');
        }
    };

    Ajax.delay = function(callback, ms) {
        clearTimeout(Ajax.delayTimer);
        Ajax.delayTimer = setTimeout(callback, ms);
    };

    return Ajax;
};
